import _ from 'lodash';
import Submission from 'edge/quoteandbind/common/models/Submission';
import conditionalProductFlow from 'integration/quoteandbind/config/ConditionalProductFlow';

export default (function ($q, GuidanceService, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx, $stateParams, StateUtils, ActionMessageUtil) {

    var questionCache = createQuestionCache();

    var ACTIONS = {
        getQuestions: function getQuestions(model) {
            return questionCache(model);
        },
        getRecommendations: function getRecommendations(model) {
            return GuidanceService.getRecommendations(model);
        },
        createAccountSubmissionAndProceedToFullQuote: function createAccountSubmissionAndProceedToFullQuote(model, productCode) {
            return GuidanceService.createAccountAndSubmission(model, productCode).then(function (submissionDTO) {
                var submission = new Submission(submissionDTO);
                var submissionViewModel = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelCtx);
                conditionalProductFlow.fullQuoteFlowDefn(submissionViewModel, productCode.code.value, $q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx, $stateParams, ActionMessageUtil);
            });
        }
    };

    function atLeastOneQuestionAnsweredYes(questionsArray) {
        return _.any(questionsArray, function (question) {
            return question.answer === true;
        });
    }

    /**
     * Function to generate the data for the questions. Caches the result to prevent an infinite digest loop
     * in Angular
     * @returns {*} - returns function that caches the data for the address and the industry codes
     */
    function createQuestionCache() {
        return _.memoize(function (model) {
            return GuidanceService.getQuestions(model);
        }, createHashFunction());
    }

    function createHashFunction() {
        return function (model) {
            return addressIndustryCodeHashFunction(model.userAddress.value, model.industryCode.value);
        };

        function addressIndustryCodeHashFunction(userAddress, industryCode) {
            return JSON.stringify(userAddress) + JSON.stringify(industryCode);
        }
    }

    return function (step, junction) {
        step('occupation', true).onNext.goTo('address').isValid(function (model) {
            return model.industryCode.value && model.industryCode.aspects.subtreeValid;
        });

        step('address').onNext.doAction(ACTIONS.getQuestions).thenGoTo('questions', 'guidanceError').isValid(function (model) {
            return model.userAddress.value && model.userAddress.aspects.subtreeValid;
        });

        step('questions').onNext.doAction(ACTIONS.getRecommendations).thenGoTo('recommendation', 'guidanceError').isValid(function (model) {
            return model.questions.value && model.questions.aspects.subtreeValid && atLeastOneQuestionAnsweredYes(model.questions.value);
        });

        step('recommendation').onNext.doAction(ACTIONS.createAccountSubmissionAndProceedToFullQuote).thenGoTo('exit', 'guidanceError').isValid(function (model) {
            return model.recommendedProducts.value;
        });

        junction('exit');

        step('guidanceError');
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/config/FlowConfig.js
// module id = 955
// module chunks = 0